import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { PricingProfileAction } from '@cbridge-packages/pricing-profile';
import { detailsSidebarResourceIdSelector, DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closePricingProfileBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(PricingProfileAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { id } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (openedDetailsId !== undefined && String(openedDetailsId) === String(id)) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
